'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isValidAmplitudeInstance = exports.isValidAmplitudeInstance = function isValidAmplitudeInstance(maybeInstance) {
  return Boolean(maybeInstance) && typeof maybeInstance.init === 'function' && typeof maybeInstance.logEvent === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/@amplitude/react-amplitude/dist/commonjs/lib/validation.js
// module id = 265
// module chunks = 0